import { Alert } from "react-bootstrap";
import DefaultSlide from "../../components/Slides/templates/DefaultSlide";
import ImageSlide from "../../components/Slides/templates/ImageSlide";
import TitleSlide from "../../components/Slides/templates/TitleSlide";
import StudentPicker from "../../components/global/StudentPicker";
import { ISlideObject } from "../../components/Slides/templates/ISlideObject";

export default function S02P01({ reveal }: ISlideObject) {
  return (
    <>
      <TitleSlide
        title="TI8512 - Desarrollo Ágil de Aplicaciones Web"
        subtitle="Semana 02 Parte 1"
      />
      <DefaultSlide title="Agenda">
        <div>
          <ul>
            <li>Aplicaciones técnicas de la tecnología web.</li>
            <li>Estándares web</li>
            <li>Navegadores web y los motores web</li>
            <li>Dispositivos para visualización web</li>
          </ul>
        </div>
      </DefaultSlide>
      <section>
        <TitleSlide title="Aplicaciones técnicas de la tecnología web"></TitleSlide>
        <ImageSlide image="/images/S02/webapps.jpg" title="Páginas web" />
        <ImageSlide
          image="/images/S02/mobileapps.jpg"
          title="Aplicaciones móviles"
        />
        <ImageSlide
          image="/images/S02/desktopapps.webp"
          title="Aplicaciones de escritorio"
        />
        <ImageSlide
          image="/images/S02/backendapps.jpg"
          title="Aplicaciones para back-end"
        />
        <DefaultSlide title="La tecnología web está en todas partes">
          <div>
            <p>
              ¿Cuál ha sido la causa del auge de tecnologías web en tantos
              ámbitos?
            </p>
            <StudentPicker number={2} />
          </div>
        </DefaultSlide>
        <DefaultSlide title="La tecnología web está en todas partes">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              ¿Cuál ha sido la causa del auge de tecnologías web en tantos
              ámbitos?
            </p>
            <ul>
              <li className="fragment">
                La simplicidad y la pequeña curva de aprendizaje de JavaScript
                permite alcanzar tiempos de despliegue de mercado (time to
                market) menores.
              </li>
              <li className="fragment">
                La eficiencia y poca demanda de las aplicaciones web para
                ejecutarse en ambientes con limitaciones de procesamiento y
                memoria.
              </li>
              <li className="fragment">
                La conveniencia del equipo de desarrollo de tener un único stack
                de tecnología aplicable a diferentes entornos de ejecución (Code
                once, deploy everywhere).
              </li>
            </ul>
          </div>
        </DefaultSlide>
      </section>
      <section>
        <TitleSlide title="Estándares Web" />
        <section>
          <p>¿Por qué es necesario estandarizar en tecnologías web?</p>
          <StudentPicker number={2} />
        </section>
        <section data-background-color="#C9F8E7">
          <p>
            Para responder la pregunta anterior, imaginemos una empresa dedicada
            a vender pintura, en donde uno de sus servicios es la creación de
            colores personalizados a partir de colores primarios (amarillo, azul
            y rojo). En un mundo estandarizado, esperaríamos que si vamos a esta
            tienda o cualquier otro negocio y pedimos el color verde, se
            aplicará la misma combinación y obtendremos el mismo resultado.
            Claramente, este no es el caso, dado que cada proveedor podría
            utilizar proporciones diferentes para generar el color verde.
          </p>
        </section>
        <section>
          <p>
            Lo mismo ocurre en el mundo de la tecnología web. Si bien existen
            estándares para el uso de tecnologías web, cada proveedor puede
            implementar estos estándares de manera diferente. Esto significa que
            un sitio web puede verse y funcionar de manera diferente en
            diferentes navegadores, lo que puede llevar a una mala experiencia
            del usuario.
          </p>
        </section>
        <DefaultSlide title="Estándares Web">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <ul>
              <li className="fragment">
                ¿Si una fuente de texto tiene color de fondo “pink" (rosado),
                qué proporción de colores debe utilizar el navegador?
              </li>
              <li className="fragment">
                ¿Cómo debe de verse un botón de forma predeterminada?
              </li>
              <li className="fragment">
                ¿Cuál es la distancia por defecto que debe tener un párrafo para
                el salto de línea?
              </li>
              <li className="fragment">
                ¿Cómo debo interpretar un codec para la visualización de
                contenido multimedia?
              </li>
              <li className="fragment">
                ¿Qué debo hacer si un usuario hace clic a un enlace?
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Estándares Web">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>En conclusión:</p>
            <ul>
              <li>La diversidad de navegadores web y motores web.</li>
              <li>
                La diversidad de dispositivos para visualizar aplicaciones web.
              </li>
              <li>
                La diversidad de sistemas operativos para ejecutar aplicaciones
                web.
              </li>
              <li className="fragment">
                Los requerimientos de accesibilidad para las aplicaciones web.
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="S02 - Tarea 1: Investigación sobre accesibilidad web">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <Alert variant="success">
              Objetivo: Investigar sobre accesibilidad web y comprender su
              importancia. <br />
              <span style={{ fontSize: "0.5em" }}>Vence: 05 Marzo 2025</span>
            </Alert>
            <p>
              Investiga sobre la accesibilidad web y responde las siguientes
              preguntas:
            </p>
            <ul>
              <li>¿Qué es la accesibilidad web?</li>
              <li>¿Por qué es importante la accesibilidad web?</li>
              <li>¿Cuáles son los estándares de accesibilidad web?</li>
              <li>
                Utilizando como base la tarea S01-Tarea 03 - Elementos de HTML,
                investiga cuáles de los elementos que habías seleccionado tienen
                alguna recomendación o limitaciones de accesibilidad.
              </li>
              <li>
                Crear documento de word con el análisis y subir a la asignación
                correspondiente
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <section>
          <p>
            Nota: Veremos más sobre accesibilidad en semanas posteriores del
            curso
          </p>
        </section>
        <DefaultSlide title="Uso de estándares web">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p>
              ¿Entonces puedo programar tranquilamente sin preocuparme por los
              estándares web dado que los navegadores se encargan de adoptar
              cada estándar?
            </p>
            <div>
              <img
                className="fragment"
                width={400}
                src="/images/S02/lagwebstandards.jpg"
                alt="Web standards lagging meme."
              />
            </div>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Uso de estándares web">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p>
              <a
                href="http://acid3.acidtests.org/"
                target="_blank"
                rel="noreferrer"
              >
                http://acid3.acidtests.org/
              </a>
              <br />
              <a
                href="https://es.wikipedia.org/wiki/Acid3"
                target="_blank"
                rel="noreferrer"
              >
                Wikipedia
              </a>
            </p>
            <div>
              <img
                width={400}
                src="/images/S02/acid.png"
                alt="Web standards lagging meme."
              />
            </div>
          </div>
        </DefaultSlide>
      </section>
      <section>
        <TitleSlide title="Navegadores web y motores web" />
        <DefaultSlide title="¿Qué es un navegador web?">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Un navegador web es una aplicación de software que permite a los
              usuarios acceder y navegar por la World Wide Web (WWW). Los
              navegadores web interpretan el código HTML, CSS y JavaScript de
              las páginas web y presentan su contenido de manera visualmente
              atractiva.
            </p>
            <p>
              Algunos de los navegadores más populares son Google Chrome,
              Mozilla Firefox, Microsoft Edge, Safari y Opera.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="¿Qué es un motor web?">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Un motor web es el componente interno de un navegador que se
              encarga de procesar y renderizar el contenido de las páginas web.
              El motor web interpreta el código HTML, CSS y JavaScript, y lo
              convierte en una representación visual que los usuarios pueden ver
              e interactuar.
            </p>
            <p>
              Cada navegador utiliza su propio motor web. Por ejemplo, Google
              Chrome utiliza Blink, Mozilla Firefox utiliza Gecko, Safari
              utiliza WebKit y Microsoft Edge utiliza EdgeHTML o Chromium.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="¿Qué es un motor web?">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Los motores web son responsables de la interpretación del código
              HTML, CSS y JavaScript, así como de la gestión de la memoria y el
              rendimiento del navegador.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Motor web: Blink">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Creado por Google a partir de WebKit en 2013 para soportar mayores
              necesidades de la empresa, entre ellas la creación de Chromium que
              es el núcleo de Google Chrome. La eficiencia y versatilidad de
              este motor a hecho que otros navegadores adopten esta herramienta,
              entre ellos Opera y Microsoft Edge.
            </p>
            <p>
              Blink se basa en el motor WebKit, que fue desarrollado por Apple.
              Blink se creó para mejorar el rendimiento y la compatibilidad con
              los estándares web.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Motor web: Gecko">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Creado por NetScape y formalizado como un proyecto de código
              abierto en 1998. Hoy es mantenido por Mozilla Foundation en su
              navegador Firefox.
            </p>
            <p>
              Gecko se creó para ser un motor de renderizado de código abierto y
              compatible con los estándares web.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Motor web: Webkit">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Creado por Apple en 2001 y lanzado como proyecto de código abierto
              en 2005. Es utilizado por Safari y iOS y consolidó la base de
              muchos otros navegadores.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="S02 - Tarea 2: Mapa mental sobre motores web">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <Alert variant="success">
              Objetivo: Crear un mapa mental sobre la importancia y funciones de
              un motor web. <br />
              <span style={{ fontSize: "0.5em" }}>Vence: 05 Marzo 2025</span>
            </Alert>
            <p>
              Lee el siguiente documento:{" "}
              <a href="https://assets.publishing.service.gov.uk/media/61b86737e90e07043c35f5be/Appendix_F_-_Understanding_the_role_of_browser_engines.pdf">
                Understanding the role of browser engines
              </a>
              . Investiga sobre los motores web y crea un mapa mental que
              incluya los siguientes puntos:
            </p>
            <ul>
              <li>¿Qué es un motor web?</li>
              <li>Importancia de los motores web en la navegación</li>
              <li>Principales motores web y sus características</li>
              <li>Funciones clave de un motor web</li>
              <li>Impacto de los motores web en la experiencia del usuario</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="S02 - Tarea 2: Mapa mental sobre motores web">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <Alert variant="success">
              Objetivo: Crear un mapa mental sobre la importancia y funciones de
              un motor web. <br />
              <span style={{ fontSize: "0.5em" }}>Vence: 05 Marzo 2025</span>
            </Alert>
            <p>
              Utiliza herramientas como Draw.io, MindMeister, XMind o cualquier
              otra herramienta de tu preferencia para crear el mapa mental. Sube
              el archivo resultante a la asignación correspondiente en formato
              PDF.
            </p>
            <p>
              Tip: Les recomiendo utilizar el plugin de Diagrams.net para VS
              Code.{" "}
              <a href="https://marketplace.visualstudio.com/items?itemName=hediet.vscode-drawio">
                https://marketplace.visualstudio.com/items?itemName=hediet.vscode-drawio
              </a>
            </p>
          </div>
        </DefaultSlide>
      </section>
      <section>
        <TitleSlide title="Dispositivos para visualización web" />
        <DefaultSlide title="Dispositivos para visualización web">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Los dispositivos para visualizar aplicaciones web son aquellos
              dispositivos electrónicos que permiten a los usuarios acceder y
              navegar por la World Wide Web (WWW). Estos dispositivos pueden
              variar en tamaño, forma y funcionalidad, pero todos comparten la
              capacidad de conectarse a Internet y mostrar contenido web.
            </p>
            <p>
              Algunos ejemplos de dispositivos para visualizar aplicaciones web
              incluyen:
            </p>
            <ul>
              <li>Computadoras de escritorio</li>
              <li>Computadoras portátiles</li>
              <li>Tabletas</li>
              <li>Teléfonos inteligentes</li>
              <li>Televisores inteligentes</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Dispositivos para visualización web">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              ¿A cuáles dispositivos debemos brindar soporte cuando estamos
              creando una aplicación web?
            </p>
            <StudentPicker number={2} />
          </div>
        </DefaultSlide>
        <DefaultSlide title="Dispositivos para visualización web">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>Según los requerimientos:</p>
            <ul>
              <li>
                ¿Es una aplicación específica para usuarios de una empresa?
              </li>
              <li>
                ¿Tenemos control del hardware que se utilizará para acceder a la
                aplicación?
              </li>
              <li>¿Se conoce el público meta de la aplicación?</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Dispositivos para visualización web">
          <div style={{ width: "100%", fontSize: "0.7em" }}>
            <p>
              Existe una amplia variedad de dispositivos y tamaños en los que se
              pueden visualizar las aplicaciones web. Solamente en dispositivos
              móviles existen más de 30 variedades de pantallas y la variedad en
              las computadoras no se queda atrás. (
              <a href="https://computerhoy.20minutos.es/moviles/ha-aumentado-tamano-pantallas-moviles-2023-1326660?form=MG0AV3">
                Así ha aumentado el tamaño de las pantallas de los móviles en
                los últimos años
              </a>
              )
            </p>
          </div>
        </DefaultSlide>
      </section>
      <ImageSlide
        image="/images/S02/party-dance.gif"
        title="¡Fin de la primera parte!"
      >
        <p>Recuerda completar todos los contenidos de la semana.</p>
        {/* <button className="btn btn-success">Marcar como completo</button> */}
      </ImageSlide>
    </>
  );
}
